import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.communityStatistics
)

export const selectCommunityStatistics = createSelector(
    baseSelector,
    (state) => state.communityStatistics
)

export const selectCommunityStatisticsLoading = createSelector(
    baseSelector,
    (state) => state.isCommunityStatistisLoading
)

export const selectCommunityStatisticsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isCommunityStatisticsFirstLoad
)

export const selectCommunityStatisticsError = createSelector(
    baseSelector,
    (state) => state.communityStatisticsError
)

export const selectCommunityTransactionStatistics = createSelector(
    baseSelector,
    (state) => state.communityTransactionStatistics
)

export const selectCommunityTransactionStatisticsLoading = createSelector(
    baseSelector,
    (state) => state.isCommunityTransactionStatistisLoading
)

export const selectCommunityTransactionStatisticsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isCommunityTransactionStatisticsFirstLoad
)

export const selectCommunityTransactionStatisticsError = createSelector(
    baseSelector,
    (state) => state.communityTransactionStatisticsError
)

export const selectRegistrationStatistics = createSelector(
    baseSelector,
    (state) => state.registrationStatistics
)

export const selectRegistrationStatisticsLoading = createSelector(
    baseSelector,
    (state) => state.isRegistrationStatisticsLoading
)

export const selectRegistrationStatisticsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isRegistrationStatisticsFirstLoad
)

export const selectRegistrationStatisticsError = createSelector(
    baseSelector,
    (state) => state.registrationStatisticsError
)

export const selectLatestUsers = createSelector(
    baseSelector,
    (state) => state.latestUsers
)

export const selectLatestUsersLoading = createSelector(
    baseSelector,
    (state) => state.isLatestUsersLoading
)

export const selectLatestUsersError = createSelector(
    baseSelector,
    (state) => state.latestUsersError
)

export const selectLatestUsersFirstLoad = createSelector(
    baseSelector,
    (state) => state.isLatestTransactionsFirstLoad
)

export const selectLatestTransactions = createSelector(
    baseSelector,
    (state) => state.latestTransactions
)

export const selectLatestTransactionsLoading = createSelector(
    baseSelector,
    (state) => state.isLatestTransactionsLoading
)

export const selectLatestTransactionsError = createSelector(
    baseSelector,
    (state) => state.latestTransactionsError
)

export const selectLatestTransactionsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isLatestTransactionsFirstLoad
)

export const selectTotalUsersCount = createSelector(
    baseSelector,
    (state) => state.totalUsersCount
)